module.exports = __webpack_public_path__ + "img/mapBottom2.73338527.png";